import React from 'react';
import { Dropdown, DropdownMenu, DropdownToggle } from 'reactstrap';

import ClickableIcon from '~components/ClickableIcon';
import { faInfoCircle } from '~components/icon';

import DropDownOption from './DropDownOption';

interface ComponentProps {
  isInfoOpen: boolean;
  setIsInfoOpen: React.Dispatch<React.SetStateAction<boolean>>;
  onHoldCount: number;
  setShowInfoModal: React.Dispatch<React.SetStateAction<boolean>>;
  setShowInfoModalProperties: React.Dispatch<
    React.SetStateAction<{ header: string; body: 'late' | 'hold' | 'exception' | null }>
  >;
  runningLateCount: number;
  exceptionCount: number;
}

export const InfoDropdown: React.FC<ComponentProps> = ({
  isInfoOpen,
  setIsInfoOpen,
  onHoldCount,
  setShowInfoModal,
  setShowInfoModalProperties,
  runningLateCount,
  exceptionCount,
}) => {
  return (
    <Dropdown isOpen={isInfoOpen} toggle={() => setIsInfoOpen(!isInfoOpen)} direction="down">
      <DropdownToggle size="sm" className="banner-icon">
        <ClickableIcon id="info-toggle" icon={faInfoCircle} toolTip="Alerts" />
      </DropdownToggle>
      <DropdownMenu>
        <DropDownOption
          iconToggle={onHoldCount > 0}
          onClick={() => {
            setShowInfoModal(true);
            setShowInfoModalProperties({
              header: 'On Hold',
              body: 'hold',
            });
          }}
          label={`On Hold (${onHoldCount})`}
        />
        <DropDownOption
          iconToggle={runningLateCount > 0}
          onClick={() => {
            setShowInfoModal(true);
            setShowInfoModalProperties({
              header: 'Running Late',
              body: 'late',
            });
          }}
          label={`Running Late (${runningLateCount})`}
        />
        <DropDownOption
          iconToggle={exceptionCount > 0}
          onClick={() => {
            setShowInfoModal(true);
            setShowInfoModalProperties({
              header: 'Exceptions',
              body: 'exception',
            });
          }}
          label={`Exceptions (${exceptionCount})`}
        />
      </DropdownMenu>
    </Dropdown>
  );
};
export default InfoDropdown;
